const _enviedkeykey2 = [
  2123212351, 3049439899, 316169144, 1574318203, 270777221, 920674091,
  3121608430, 2807915887, 1018208757, 1140337221, 1137011684, 1442993223,
  2667069983, 3198804311, 2897379580, 4004222877, 2419049177, 3313731145,
  519113887, 667811555, 1658518711, 269493217, 2307356919, 2805139970,
  3814275906, 3150762849, 3618191918, 4067649613,
];

const _envieddatakey2 = [
  2123212377, 3049439991, 316169181, 1574318096, 270777316, 920674140,
  3121608325, 2807915785, 1018208671, 1140337184, 1137011603, 1442993190,
  2667070064, 3198804273, 2897379477, 4004222962, 2419049134, 3313731119,
  519113973, 667811461, 1658518720, 269493120, 2307356817, 2805140074,
  3814275881, 3150762756, 3618191961, 4067649580,
];

const getkey = () => {
  const indices = Array.from({ length: _envieddatakey2.length }, (_, i) => i);
  return indices
    .map((i) => String.fromCharCode(_envieddatakey2[i] ^ _enviedkeykey2[i]))
    .join("");
};

async function decryptImage(imgBytes) {
  const key = getkey();
  try {
    if (imgBytes.length === 0) return imgBytes;
    const decryptedBytes = new Uint8Array(imgBytes);
    const l = Math.min(imgBytes.length, 10);
    for (let i = 0; i < l; i++) {
      decryptedBytes[i] ^= key.charCodeAt(i % key.length);
    }
    return decryptedBytes;
  } catch (error) {
    return imgBytes;
  }
}

const imageURLDecrypt = async (url) => {
  if (url[url.length - 1] === "/") {
    return;
  }

  try {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    const imgBytes = new Uint8Array(arrayBuffer);
    const processedImage = await decryptImage(imgBytes);
    const blob = new Blob([processedImage], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.log(error);
  }
};

export default imageURLDecrypt;
